export const BASE_URL = "http://123.56.170.62:9999/"
export function moneyFormat (money, len) {
  if (!money && money != 0) return '0.00'
  if (isNaN(+money)) return '0.00'
  len = len
  let arr = (money + '').split('.')
  let intStr = arr[0] ? arr[0] : 0
  let floatStr = arr[1] ? arr[1] : 0
  if (floatStr == 0) {
    floatStr = 0
    for (var i = 0; i < len - 1; i++) {
      floatStr += '0'
    }
  } else {
    floatStr = (+('0.' + floatStr)).toFixed(len).split('.')[1]
  }
  if(len){
    money = (intStr + '.' + floatStr).replace(/(\d{1,3})(?=(?:\d{3})+\.)/g, '$1,')
  }else{
    money = (intStr ).replace(/(\d{1,3})(?=(?:\d{3}))/g, '$1,')
  }
  return money
}